<div class="header">対象者選択</div>

<mat-dialog-content class="dialog-content" autofocus>
  @if (showSpinner) {
    <div class="spinner center">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <!-- 検索フォーム -->
    <div class="search-form">
      <!-- 役職 -->
      <div class="form-row">
        <label class="form-label">役職</label>
        <mat-form-field appearance="outline" class="position-select">
          <mat-select [(ngModel)]="selectedPosition" (selectionChange)="onSearch()">
            <mat-option [value]="null"></mat-option>
            @for (pos of officialPositions; track pos.value) {
              <mat-option [value]="pos.value">{{ pos.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- 名前 -->
      <div class="form-row">
        <label class="form-label">名前</label>
        <div class="name-inputs">
          <input type="text" class="name-input" [(ngModel)]="lastName"
            placeholder="姓" (blur)="onSearch()" (keydown.enter)="onEnter($event)">
          <input type="text" class="name-input" [(ngModel)]="firstName"
            placeholder="名" (blur)="onSearch()" (keydown.enter)="onEnter($event)">
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>

    <!-- 検索結果 -->
    <div class="search-results">
      @if (isSearching) {
        <div class="results-spinner">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      @if (!isSearching && hasSearched) {
        <div class="results-list">
          @for (member of searchResults; track member.id) {
            <div class="result-item" [class.selected]="isSelected(member)" (click)="toggleMember(member)">
              <mat-checkbox
                class="thin-checkbox"
                [checked]="isSelected(member)"
                (click)="$event.stopPropagation()"
                (change)="toggleMember(member)"
              />
              <div class="member-details">
                @if (member.position) {
                  <div class="member-name">{{ member.position }}　{{ member.name }}</div>
                } @else {
                  <div class="member-name">{{ member.name }}</div>
                }
                <div class="member-affiliations">
                  @for (aff of member.affiliations; track $index) {
                    <div class="affiliation-row">
                      <div class="dot">・</div>
                      <div>{{ aff }}</div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          @if (searchResults.length === 0) {
            <div class="no-results">該当するメンバーが見つかりません。</div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="actions-content">
  <button mat-raised-button (click)="onCancel()">キャンセル</button>
  <button mat-raised-button (click)="onSelect()" class="yes-btn">選択</button>
</mat-dialog-actions>
